export default "__VITE_ASSET__iW6ECmV4__"